import { render, staticRenderFns } from "./Index-coinbase.vue?vue&type=template&id=5f629dfe&scoped=true"
import script from "./Index-coinbase.vue?vue&type=script&lang=js"
export * from "./Index-coinbase.vue?vue&type=script&lang=js"
import style0 from "./Index-coinbase.vue?vue&type=style&index=0&id=5f629dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f629dfe",
  null
  
)

export default component.exports